import { Component, Input, OnInit } from '@angular/core';
import {Athlete} from "../../../models/athlete";
import {Router } from "@angular/router";
import {UserService} from "../../../services/user/user.service";
import {ParentService} from "../../../services/parent/parent.service";
import Swal, {SweetAlertResult} from "sweetalert2";
import {AthleteService} from "../../../services/athlete/athlete.service";
import {athleteSeasonStatus, AthleteStatusInfo} from "../../../resources/athlete-status";

@Component({
    selector: 'ui-athlete-card',
    templateUrl: './athlete-card.component.html'
})
export class AthleteCardComponent {
    @Input('athlete') athlete: Athlete = new Athlete();

    constructor(private router: Router,
                public athleteService: AthleteService) {
    }


    get status(): AthleteStatusInfo {
        return athleteSeasonStatus(this.athlete.seasonStatus);
    }

    /** Parametri per riaprire la pagina con le istruzioni di pagamento (bonifico o segreteria). */
    get paymentInstructionsQuery(): Record<string, boolean> {
        return this.athlete.athleteSeasons?.[0]?.athletePaymentRequest?.paymentMethod === 'transfer' ? {ibanSelected: true} : {};
    }

    hasPendingOfflinePayment(): boolean {
        const request = this.athlete.athleteSeasons?.[0]?.athletePaymentRequest;
        return !!request &&
            (request.paymentMethod == 'transfer' || request.paymentMethod == 'localPayment') &&
            request.status == 'pendingPayment';
    }

    // Athlete validation
     athleteCompleted(): boolean {
        return (
            this.athlete.firstName.trim() !== '' &&
            this.athlete.lastName.trim() !== '' &&
            this.athlete.bornCity.trim() !== '' &&
            this.athlete.bornDate.trim() !== '' &&
            this.athlete.fiscalCode.trim() !== '' &&
            !!(this.athlete.address && this.athlete.address.trim() !== '') &&
            !!(this.athlete.city && this.athlete.city.trim() !== '') &&
            !!(this.athlete.province && this.athlete.province.trim() !== '') &&
            !!(this.athlete.phone && this.athlete.phone.trim() !== '') &&
            !!(this.athlete.email && this.athlete.email.trim() !== '')
        );
    }



    navigateToPayment(): void {
        if (!this.athleteCompleted()) {
            return;
        }
        this.router.navigate(['/users/payment', this.athlete.id]);

    }

    deletePaymentRequest(athleteId: string) {
        Swal.fire({
            icon: 'warning',
            title: "Sei sicuro di voler eliminare la richiesta di pagamento?",
            showCancelButton: true,
            confirmButtonText: "Si, elimina la richiesta di pagamento",
            cancelButtonText: "No, annulla l'operazione"
        })
            .then( async (response: SweetAlertResult) => {
                if (response.isConfirmed) {
                    if ( (await this.athleteService.deletePaymentRequest(athleteId)).success ){
                        Swal.fire({
                            icon: 'success',
                            title: 'Richiesta di pagamento eliminata con successo'
                        }).then(() => { window.location.reload() })
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: "Errore nella cancellazione del documento, riprova"
                        })
                    }
                }
                if (response.isDismissed) {
                    // niente
                }
            });
    }
}
